import { app } from '@/main';
import { Route } from '../route.model';
import AdminOffers from '@/views/Admin/Offers/AdminOffers.vue';
import { SuperAdminPermission } from '@/models/super-admin';

const validateRouteFlag = () => {
  const permissions = app.$store.getters['manager/getPermissions'];

  return [SuperAdminPermission.OfferUpdate].some(permission =>
    permissions.includes(permission)
  );
};

const adminOffers = new Route('/admin/offers', 'offers', AdminOffers, {
  requiresAuth: true,
  superRoot: true,
  navbar: {
    name: 'Offers', // TODO apply i18n
    icon: 'coin-rewarded'
  },
  zendesk: {
    disabled: true
  },
  customFlagValidator: validateRouteFlag
});

export { adminOffers };
export default adminOffers;
